import Vue from 'vue';

import {firebase, firestorePlugin, FireStoreUploader} from './firebase';
import {inIframe} from './generalFunctions';


function initFireBase(token) {
  return new Promise((resolve, reject) => {

    firebase.auth().signInWithCustomToken(token.data.token).then((res) => {

      Vue.use(firestorePlugin)

      Vue.prototype.$FB = firebase.firestore()
      Vue.prototype.$FB_STORAGE = firebase.storage()
      Vue.prototype.$FBClient = firebase
      Vue.prototype.$FB_UPLOADER = new FireStoreUploader(firebase.storage())
      resolve()
    }).catch(function (error) {
      reject(error)
      var errorCode = error.code;
      var errorMessage = error.message;
    });
  })
}

export default initFireBase